<link rel="preconnect" href="https://fonts.googleapis.com">
<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
<link
    href="https://fonts.googleapis.com/css2?family=Montserrat:wght@100;400&family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap"
    rel="stylesheet">
<div class="main-container">
    <div class="header-fixed">
        <div class="text-center p-38">
            <img src="../../assets/img/formlogo.png"
                style="height: 48px; width: 171px;">
        </div>
    <progress class="progress-bar-div" value="0" max="100"></progress>
</div>
<div class="sub-container row">
  <div class="content">
    <h2>Thank you for submitting your form.</h2>
    <p>Your care team will go over your answers and reach out to you if they have any questions.</p>
  </div>
</div>
</div>

